import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { ROUTES } from '../../constants'
import './styles.scss'

const NotFound = () => {
  const navigate = useNavigate()

  return (
    <div className="not-found">
      <div className="not-found__inner">
        <div className="not-found__code">
          <span className="digit">4</span>
          <span className="digit highlight">0</span>
          <span className="digit">4</span>
        </div>

        <div className="not-found__divider" />

        <h1 className="not-found__title">Package Not Found</h1>

        <p className="not-found__subtitle">
          The page you're looking for seems to have gone missing in transit.
        </p>

        <div className="not-found__actions">
          <button
            className="not-found__btn not-found__btn--primary"
            onClick={() => navigate('/')}
          >
            <FontAwesomeIcon icon={solid('house')} />
            Back to Home
          </button>

          <button
            className="not-found__btn not-found__btn--outline"
            onClick={() => navigate(ROUTES.trackIt)}
          >
            <FontAwesomeIcon icon={solid('magnifying-glass')} />
            Track Your Package
          </button>
        </div>
      </div>
    </div>
  )
}

export default NotFound
